import { useEffect } from 'react';
import './App.css';
import QuizPage from './components/QuizPage';
import ShareImagePreview from './components/ShareImagePreview';
import ResultsPreview from './components/ResultsPreview';
import ResultsPage from './components/ResultsPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { analytics } from './firebase';
import { analyticsService } from './services/analyticsService';

function App() {
  // Initialize analytics service on mount
  useEffect(() => {
    // Initialize with Firebase analytics instance
    analyticsService.init(analytics);

    // Capture UTM parameters from URL
    analyticsService.captureUtmParams();
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<QuizPage />} />
          <Route path="/share-preview" element={<ShareImagePreview />} />
          <Route path="/results-preview" element={<ResultsPreview />} />
          <Route path="/results/:sessionId" element={<ResultsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
